import * as types from './types'
import http from '../../utils/http'

const state = {
  headTip: '', // 提示：当前页面统计的是以下仓库的数据之和
  totalList: [], // 供应商账单总金额排名TOP10
  unpaidList: {list: []}, // 近一年未支付账单累计
  count: {
    inventory: 0, // 总库存
    supplier: 0, // 供应商总数
    sku: 0, // sku种数
    value: 0 // 总货值
  },
  task: { // 今日任务数
    notAccept: 0, // 未接单
    accept: 0, // 已接单
    cansel: 0, // 已取消
    chartsData: {} // 图表数据
  },
  // 仓库出货量统计
  shipment: {}
}

const actions = {
  // 获取供应商总数
  [types.GETSUPPLIERCOUNT] (context, params) {
    http.fetch('/api/index/getSupplierCount', params).then(data => {
      context.commit(types.GETSUPPLIERCOUNT, data)
    })
  },
  // 近一年未支付账单累计
  [types.GETUNPAIDBILLINONEYEAR] (context, params) {
    http.fetch('/api/index/getUnpaidBillInOneYear', params).then(data => {
      context.commit(types.GETUNPAIDBILLINONEYEAR, data)
    })
  },
  // 供应商账单总金额排名TOP10
  [types.GETBILLTOTALMONEYRANKING] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/index/getBillTotalMoneyRanking', params).then(data => {
        resolve(data.obj)
      })
    })
  },
  // 提示：当前页面统计的是以下仓库的数据之和
  [types.GETHEADTIP] (context, params) {
    http.fetch('/api/index/getHeadTip', params).then(data => {
      context.commit(types.GETHEADTIP, data)
    })
  },
  // 获取总库存、sku种数、今日任务数
  [types.GETNOWEXTSKUTASK] (context, params) {
    http.fetch('/api/index/getNowExtSkuTask', params).then(data => {
      context.commit(types.GETNOWEXTSKUTASK, data)
    })
  },
  // 仓库出货量统计
  [types.GETMAXSOLD] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/index/getMaxSold', params).then(data => {
        resolve(data.obj)
      })
    })
  },
  // Saas首页数据
  [types.GETSAASHOMEPAGETOP] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/index/getSaasHomepageTop', params).then(data => {
        resolve(data.obj)
      })
    })
  },
  // Saas首页出货量统计
  [types.GETSAASHOMEPAGEBELOW] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/index/getSaasHomepageBelow', params).then(data => {
        resolve(data.obj)
      })
    })
  }
}

const mutations = {
  // 获取供应商总数
  [types.GETSUPPLIERCOUNT] (state, data) {
    state.count.supplier = data.obj
  },
  // 近一年未支付账单累计
  [types.GETUNPAIDBILLINONEYEAR] (state, data) {
    state.unpaidList = data.obj
  },
  // 供应商账单总金额排名TOP10
  [types.GETBILLTOTALMONEYRANKING] (state, data) {
    state.totalList = data.obj
  },
  // 提示：当前页面统计的是以下仓库的数据之和
  [types.GETHEADTIP] (state, data) {
    state.headTip = data.obj
  },
  // 获取总库存、sku种数、今日任务数
  [types.GETNOWEXTSKUTASK] (state, data) {
    data = data.obj
    state.count.sku = data.sku
    state.count.inventory = data.ext
    state.count.value = data.value
    if (data.taskMap) {
      state.task = data.taskMap
    }
    state.task.chartsData = data.taskList
  },
  // 仓库出货量统计
  [types.GETMAXSOLD] (state, data) {
    state.shipment = data.obj
  },
  [types.GETSAASHOMEPAGETOP] (state, data) {
  },
  [types.GETSAASHOMEPAGEBELOW] (state, data) {
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/home/index.js